import { EFinancingProgram } from '@if/core/types'
import { MechanicalWarrantyComputeRequestDto } from '@src/containers/EditWorksheet/EditMechanicalWarrantyWorksheetPage/types/ComputeMechanicalWarrantyRequestDto'
import { MechanicalWarrantyComputeResultDto } from '@src/containers/EditWorksheet/EditMechanicalWarrantyWorksheetPage/types/ComputeMechanicalWarrantyResultDto'
import {
  MechanicalWarrantyDecisionDTO,
  MechanicalWarrantyWorksheet,
  MechanicalWarrantyWorksheetDto,
} from '@src/containers/EditWorksheet/EditMechanicalWarrantyWorksheetPage/types/mechanicalWarrantyWorksheetSchema'
import configApi from '@src/data/api/config/config-api'
import { FinancingProgramProvider } from '@src/data/types/FinancingProgramProvider'
import { MechanicalWarrantyProduct } from '@src/data/types/MechanicalWarrantyProduct'
import allApi from '../../api'
import { makeGetById, makeGetListWithIds, makeSave } from '../effects/standard-side-effects'
import {
  COMPUTE_MECHANICAL_WARRANTY_LOAN,
  GET_MECHANICAL_WARRANTY_PROVIDER,
  GET_MECHANICAL_WARRANTY_PROVIDER_PRODUCTS,
  GET_MECHANICAL_WARRANTY_WORKSHEET,
  MechanicalWarrantyWorksheetSlice,
  SAVE_MECHANICAL_WARRANTY_WORKSHEET,
  SAVE_MECHANICAL_WARRANTY_WORKSHEET_DECISION
} from './mechanical-warranty-worksheet-store'

const mechanicalWarrantyWorksheetEffects = {
  getById: (id: string) =>
    makeGetById<MechanicalWarrantyWorksheet>(
      GET_MECHANICAL_WARRANTY_WORKSHEET,
      allApi.mechanicalWarrantyWorksheet.getById,
      MechanicalWarrantyWorksheetSlice.actions.setCurrent,
      {
        id,
      },
    ),
  create: (data: MechanicalWarrantyWorksheetDto) =>
    makeSave<MechanicalWarrantyWorksheetDto, MechanicalWarrantyWorksheet>(
      SAVE_MECHANICAL_WARRANTY_WORKSHEET,
      allApi.mechanicalWarrantyWorksheet.create,
      MechanicalWarrantyWorksheetSlice.actions.setCurrent,
      data,
    ),
  update: (data: MechanicalWarrantyWorksheetDto) =>
    makeSave<MechanicalWarrantyWorksheetDto, MechanicalWarrantyWorksheet>(
      SAVE_MECHANICAL_WARRANTY_WORKSHEET,
      allApi.mechanicalWarrantyWorksheet.update,
      MechanicalWarrantyWorksheetSlice.actions.setCurrent,
      data,
    ),
  computeMechanicalWarrantyLoan: (data: MechanicalWarrantyComputeRequestDto) =>
    makeSave<MechanicalWarrantyComputeRequestDto, MechanicalWarrantyComputeResultDto>(
      COMPUTE_MECHANICAL_WARRANTY_LOAN,
      allApi.mechanicalWarrantyWorksheet.computeMechanicalWarrantyLoan,
      MechanicalWarrantyWorksheetSlice.actions.setLoanComputed,
      data,
    ),

  getMechanicalWarrantyProviders: (merchantId: string) =>
    makeGetListWithIds<FinancingProgramProvider>(
      GET_MECHANICAL_WARRANTY_PROVIDER,
      configApi.getMerchantProviderByType,
      MechanicalWarrantyWorksheetSlice.actions.setProviders,
      { merchantId, financingProgramId: EFinancingProgram.MechanicalWarranty },
    ),

  getMechanicalWarrantyProviderProducts: (merchantId: string, providerId: string) =>
    makeGetListWithIds<MechanicalWarrantyProduct>(
      GET_MECHANICAL_WARRANTY_PROVIDER_PRODUCTS,
      configApi.getMerchantProviderProducts,
      MechanicalWarrantyWorksheetSlice.actions.setProductsByProvider,
      { merchantId, financingProgramId: EFinancingProgram.MechanicalWarranty, providerId },
    ),
    updateDecision: (data: MechanicalWarrantyDecisionDTO) =>
      makeSave<MechanicalWarrantyDecisionDTO, MechanicalWarrantyWorksheet>(
        SAVE_MECHANICAL_WARRANTY_WORKSHEET_DECISION,
        allApi.mechanicalWarrantyWorksheet.updateDecision,
        MechanicalWarrantyWorksheetSlice.actions.setCurrent,
        data,
  ),
}

export default mechanicalWarrantyWorksheetEffects
